import { Box, Button, Grid, Typography } from '@mui/material';
import { ErrorIllustration } from '../../assets/illustration';
import { fonts } from '../../theme/typography';
import { AppIcon } from '../app-icon/AppIcon';
import { ERROR_MESSAGES } from '../error/constants';

interface ModalErrorProps {
  errorStatus?: number | string;
  errorTitle?: string;
  handleCancel?: React.MouseEventHandler<HTMLButtonElement>;
  retryBtnLabel?: string;
  cancelBtnLabel?: string;
  message?: string;
  handleRetry?: React.MouseEventHandler<HTMLButtonElement>;
}

export const ModalError: React.FC<ModalErrorProps> = ({
  errorStatus = 'default',
  handleCancel,
  handleRetry,
  errorTitle,
  retryBtnLabel = 'Try Again',
  cancelBtnLabel = 'Cancel',
  message,
}) => {
  const errorMessage = ERROR_MESSAGES[errorStatus] || ERROR_MESSAGES['default'];

  return (
    <Box>
      <Box sx={{ maxWidth: errorTitle ? 'none' : '25em', m: 'auto', textAlign: 'center' }}>
        <Box sx={{ mb: 7.5 }}>
          <AppIcon
            sx={{ height: '10rem', width: 'auto' }}
            titleAccess={errorMessage.title}
            Icon={ErrorIllustration}
            role="presentation"
          />
        </Box>
        <Typography
          color="error"
          component="h6"
          fontFamily={fonts.heading}
          fontWeight="Bold"
          variant="large"
          sx={{ mb: 3 }}
        >
          {errorTitle || (
            <>
              Oops..
              <br />
              {errorMessage.title}
            </>
          )}
        </Typography>
        {!errorTitle && (
          <Typography paragraph variant="medium" color="secondary">
            {message || errorMessage.message}
          </Typography>
        )}
        {(handleCancel || handleRetry) && (
          <Grid justifyContent="center" container spacing={1.5}>
            {handleCancel && (
              <Grid item>
                <Button onClick={handleCancel} variant="default">
                  {cancelBtnLabel}
                </Button>
              </Grid>
            )}
            {handleRetry && (
              <Grid item>
                <Button onClick={handleRetry} variant="contained">
                  {retryBtnLabel}
                </Button>
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    </Box>
  );
};
